export default "__VITE_ASSET__4757ae6b__"